import ScrollToTopOnMount from "../../components/ScrollToTopOnMount/ScrollToTopOnMount";
import Auction from "../../layouts/Auction/Auction";


const Auctionpage = () => {
    return (
        <>
            <ScrollToTopOnMount />
            <Auction />
        </>
    )
}

export default Auctionpage;